var webooker_acivity_models = webooker_acivity_models || {};

(function (ns) {

    // #region ActivityAttendance - Ctor 
    ns.ActivityAttendance = function ActivityAttendance(
        schedule,
        reservation,
        attendance,
        activityStudentSetting,
        activity,
        tenantSetting,
        numberOfExcuses,
        studentID,
        momentNow) {

        this.schedule = schedule;
        this.reservation = reservation;
        this.attendance = attendance;

        this.activityStudentSetting = activityStudentSetting;
        this.activity = activity;
        this.tenantSetting = tenantSetting;
        
        this.momentNow = momentNow || function () { return moment(); }

        this.calculateProperties(studentID, numberOfExcuses);

        this.origAttendance = this.getServerAttendance();
    }

    // #endregion

    // #region ActivityAttendance - Methods

    ns.ActivityAttendance.prototype.clone = function () {
        var newObj = new ns.ActivityAttendance(
            this.schedule,
            this.reservation,
            !!this.attendance ? angular.copy(this.attendance) : this.attendance,
            this.activityStudentSetting,
            this.activity,
            this.tenantSetting,
            this.numberOfExcuses,
            this.studentID,
            this.momentNow
        );

        return newObj;
    }

    ns.ActivityAttendance.prototype.calculateProperties = function (studentID, numberOfExcuses, attendance, schedule) {
        if (attendance) {
            this.attendance = attendance;
        }

        if (schedule) {
            this.schedule = schedule;
        }

        this.numberOfExcuses = numberOfExcuses;

        var rdata = this.attendance || this.reservation;
        var data = rdata || this.schedule;        

        this.studentFullName = rdata ? rdata.studentFullName : null;
        this.studentID = rdata ? rdata.studentID : studentID;

        this.activityAttendanceID = data.activityAttendanceID || 0;
        this.activityScheduleID = data.activityScheduleID;
        this.activityID = data.activityID;

        this.firstPeriodStartDate = this.normalizeDate(data.firstPeriodStartDate);
        this.firstPeriodEndDate = this.normalizeDate(data.firstPeriodEndDate);
        this.secondPeriodStartDate = this.normalizeDate(data.secondPeriodStartDate);
        this.secondPeriodEndDate = this.normalizeDate(data.secondPeriodEndDate);
        this.lunch = data.lunch;
        this.firstSnack = data.firstSnack;
        this.secondSnack = data.secondSnack;
        this.notes = rdata != null ? rdata.notes : null;
        this.scheduleNotes = this.schedule.notes;
        this.confirmed = this.activityAttendanceID !== 0 ? data.confirmed : false;
        this.firstPeriodFilled = this.schedule ? this.schedule.firstPeriodFilled : null;
        this.secondPeriodFilled = this.schedule ? this.schedule.secondPeriodFilled : null;
        this.firstPeriodCapacity = this.schedule ? this.schedule.firstPeriodCapacity : null;
        this.secondPeriodCapacity = this.schedule ? this.schedule.secondPeriodCapacity : null;

        this.firstPeriodWaitQueuePosition = !!this.attendance
            ? this.attendance.firstPeriodWaitQueuePosition
            : _.findIndex(this.schedule.firstPeriodWaitQueue, ['studentID', this.studentID]) + 1;

        this.secondPeriodWaitQueuePosition = !!this.attendance
            ? this.attendance.secondPeriodWaitQueuePosition
            : _.findIndex(this.schedule.secondPeriodWaitQueue, ['studentID', this.studentID]) + 1;

        if (this.attendance) {
            this._firstPeriodAttendanceStatusID = data.firstPeriodAttendanceStatusID;
            this.firstPeriodAttendanceTypeID = data.firstPeriodAttendanceTypeID;
            this._secondPeriodAttendanceStatusID = data.secondPeriodAttendanceStatusID;
            this.secondPeriodAttendanceTypeID = data.secondPeriodAttendanceTypeID;

        } else if (this.reservation) {
            this._firstPeriodAttendanceStatusID = !!this.reservation.firstPeriodStartDate ? 0 : 1;
            this.firstPeriodAttendanceTypeID = 0; // Registered
            this._secondPeriodAttendanceStatusID = !!this.reservation.secondPeriodStartDate ? 0 : 1;
            this.secondPeriodAttendanceTypeID = 0; // Registered
        } else {
            this._firstPeriodAttendanceStatusID = 1;
            this.firstPeriodAttendanceTypeID = 0;
            this._secondPeriodAttendanceStatusID = 1;
            this.secondPeriodAttendanceTypeID = 0;
        }
    }

    ns.ActivityAttendance.prototype.getServerAttendance = function () {

        var activityAttendance = {};

        activityAttendance.studentID = this.studentID;
        activityAttendance.activityAttendanceID = this.activityAttendanceID;
        activityAttendance.activityScheduleID = this.activityScheduleID;
        activityAttendance.activityID = this.activityID;

        if (!this.noReservationFirstPeriod) {
            activityAttendance.firstPeriodStartDate =
                this.deNormalizeDate(this.firstPeriodStartDate, this.schedule.firstPeriodStartDate);
            activityAttendance.firstPeriodEndDate =
                this.deNormalizeDate(this.firstPeriodEndDate, this.schedule.firstPeriodEndDate);

            activityAttendance.lunch = this.lunch;
            activityAttendance.firstSnack = this.firstSnack;
        } else {
            activityAttendance.lunch = false;
            activityAttendance.firstSnack = false;
        }

        if (!this.noReservationSecondPeriod) {
            activityAttendance.secondPeriodStartDate =
                this.deNormalizeDate(this.secondPeriodStartDate, this.schedule.secondPeriodStartDate);
            activityAttendance.secondPeriodEndDate =
                this.deNormalizeDate(this.secondPeriodEndDate, this.schedule.secondPeriodEndDate);
            activityAttendance.secondSnack = this.secondSnack;
        } else {
            activityAttendance.secondSnack = false;
        }

        activityAttendance.notes = this.notes;
        activityAttendance.confirmed = this.confirmed;

        activityAttendance.firstPeriodAttendanceTypeID = this.firstPeriodAttendanceTypeID;
        activityAttendance.firstPeriodAttendanceStatusID = this.firstPeriodAttendanceStatusID;
        activityAttendance.secondPeriodAttendanceTypeID = this.secondPeriodAttendanceTypeID;
        activityAttendance.secondPeriodAttendanceStatusID = this.secondPeriodAttendanceStatusID;

        activityAttendance.firstPeriodWaitQueuePosition = this.firstPeriodWaitQueuePosition;
        activityAttendance.secondPeriodWaitQueuePosition = this.secondPeriodWaitQueuePosition;

        return activityAttendance;
    }

    ns.ActivityAttendance.prototype.normalizeDate = function (date) {
        if (!date) {
            return date;
        }

        var mvalue = moment(date);
        return new Date(1970, 0, 1, mvalue.hours(), mvalue.minutes());
    }

    ns.ActivityAttendance.prototype.deNormalizeDate = function (date, scheduleDate) {
        if (!date) {
            return date;
        }

        var mvalue = moment(date);
        var mscheduleDate = moment(scheduleDate);
        return new Date(mscheduleDate.year(), mscheduleDate.month(), mscheduleDate.date(), mvalue.hours(), mvalue.minutes());
    }


     ns.ActivityAttendance.prototype.getExcuseType = function(periodStartDate, now) {
        if (this.isWithinActivityExcuseWithoutFoodTimeLimit(periodStartDate, now)) {
            return 2; // NotPresentExcused;
        }

        if (this.isWithinActivityExcuseTimeLimit(periodStartDate, now)) {
            return 4; // NotPresentExcusedWithoutFood;
        }

        return 3; //NotPresentExcusedNoCompensation;
     }

     ns.ActivityAttendance.prototype.isWithinActivityExcuseWithoutFoodTimeLimit = function (lessonStartDate, now) {
         return this.isWithinThresholdTimeLimit(
             this.tenantSetting.activityExcuseWithoutFoodThresholdType,
             this.tenantSetting.activityExcuseWithoutFoodThreshold,
             lessonStartDate,
             now);
     }

     ns.ActivityAttendance.prototype.isWithinActivityExcuseTimeLimit = function(lessonStartDate, now) {
         return this.isWithinThresholdTimeLimit(
             this.tenantSetting.activityExcuseThresholdType,
             this.tenantSetting.activityExcuseThreshold,
             lessonStartDate,
             now);
     }

     ns.ActivityAttendance.prototype.isWithinThresholdTimeLimit = function(thresholdType, threshold, lessonStartDate, now) {

         let mLessonStartDate = moment(lessonStartDate);
         let mNow = moment(now);

         switch (thresholdType) {
             case 0: // ExcuseThresholdType.NoOfHoursBeforeStart:
                 return moment.duration(mLessonStartDate.diff(mNow)).asHours() > threshold;
             case 1: // ExcuseThresholdType.AtSpecificTimeOnStartDate:
                 return mNow.isBefore(mLessonStartDate.startOf('day').add(threshold, 'hours'));
             case 2: // ExcuseThresholdType.AtSpecificTimeOnDateBeforeStartDate:
                 return mNow.isBefore(mLessonStartDate.startOf('day').add(threshold, 'hours').subtract(1, 'day'));
             case 3: // ExcuseThresholdType.AtSpecificTimeOnPrevBusinessDay:
                 return mNow.isBefore(mLessonStartDate.startOf('day').add(threshold, 'hours').subtract(
                     this.getNoOfDaysToPrevBusinessDay(mLessonStartDate), 'day'));
             case 4: // ExcuseThresholdType.AtSpecificTimeOnPrevPrevBusinessDay:
                 return mNow.isBefore(mLessonStartDate.startOf('day').add(threshold, 'hours').subtract(
                     this.getNoOfDaysToPrevPrevBusinessDay(mLessonStartDate), 'day'));                 
         }

         return false;
     }

     ns.ActivityAttendance.prototype.getNoOfDaysToPrevBusinessDay = function(pivot) {
         switch (pivot.isoWeekday()) {
             case 1: // Monday
                 return 3;
             case 7: // Sunday
                 return 2;
             default:
                 return 1;
         }
     }

    ns.ActivityAttendance.prototype.getNoOfDaysToPrevPrevBusinessDay = function(pivot) {
        switch (pivot.isoWeekday()) {
            case 1: // Monday
                return 4;
            case 2: // Tuesday
                return 4;                
            case 7: // Sunday
                return 3;
            default:
                return 2;
        }
    }     


     ns.ActivityAttendance.prototype.bookFirstPeriod = function (book /* boolean */, waitQueueOperation /* boolean */) {
         var shouldDisableFirstPeriodBooking = !this.schedule.firstPeriodStartDate;
         if (!shouldDisableFirstPeriodBooking) {
             if (!book) {
                 // Return to orig state
                 this._firstPeriodAttendanceStatusID = this.origAttendance.firstPeriodAttendanceStatusID;
                 this.firstPeriodAttendanceTypeID = this.origAttendance.firstPeriodAttendanceTypeID;
             } else {
                 if (this.origAttendance.firstPeriodAttendanceStatusID == 1 /* NotPresentNotExcused */ &&
                     this.origAttendance.firstPeriodAttendanceTypeID == 0 /* Registered */ &&
                     (!this.reservation || !this.reservation.firstPeriodStartDate)) {
                     switch (this.activityStudentSetting.activityCompensationTypeID) {
                         case 0: // ActivityCompensationType.OneExcuseForOneCompensation
                             if (this.numberOfExcuses > 0) {
                                 this.numberOfExcuses = waitQueueOperation
                                    ? this.numberOfExcuses
                                    : this.numberOfExcuses - 1;
                                 this.firstPeriodAttendanceStatusID = 0; /* Present */
                                 this.firstPeriodAttendanceTypeID = 2; /* Amend */
                             } else {
                                 this.firstPeriodAttendanceTypeID = 1; /* OneOff */
                                 this.firstPeriodAttendanceStatusID = 0; /* Present */
                             }
                             break;
                         case 1: // ActivityCompensationType.TwoExcusesForOneCompensation
                             if (this.numberOfExcuses > 1) {
                                 this.numberOfExcuses = waitQueueOperation
                                    ? this.numberOfExcuses
                                    : this.numberOfExcuses - 2;
                                 this.firstPeriodAttendanceStatusID = 0; /* Present */
                                 this.firstPeriodAttendanceTypeID = 2; /* Amend */
                             } else {
                                 this.firstPeriodAttendanceTypeID = 1; /* OneOff */
                                 this.firstPeriodAttendanceStatusID = 0; /* Present */
                             }
                             break;
                         case 2: // ActivityCompensationType.CompensationsDisabled
                             this.firstPeriodAttendanceTypeID = 1; /* OneOff */
                             this.firstPeriodAttendanceStatusID = 0; /* Present */
                             break;
                     }
                 } else {
                     this.firstPeriodAttendanceStatusID = 0; /* Present */;
                 }
             }
         }
     }

     ns.ActivityAttendance.prototype.bookSecondPeriod = function (book /* boolean */, waitQueueOperation /* boolean */) {
         var shouldDisableSecondPeriodBooking = !this.schedule.secondPeriodStartDate;
         if (!shouldDisableSecondPeriodBooking) {
             if (!book) {
                 // Return to orig state
                 this._secondPeriodAttendanceStatusID = this.origAttendance.secondPeriodAttendanceStatusID;
                 this.secondPeriodAttendanceTypeID = this.origAttendance.secondPeriodAttendanceTypeID;
             } else {
                 if (this.origAttendance.secondPeriodAttendanceStatusID == 1 /* NotPresentNotExcused */ &&
                     this.origAttendance.secondPeriodAttendanceTypeID == 0 /* Registered */ &&
                     (!this.reservation || !this.reservation.secondPeriodStartDate)) {
                     switch (this.activityStudentSetting.activityCompensationTypeID) {
                         case 0: // ActivityCompensationType.OneExcuseForOneCompensation
                             if (this.numberOfExcuses > 0) {
                                 this.numberOfExcuses = waitQueueOperation
                                    ? this.numberOfExcuses
                                    : this.numberOfExcuses - 1;
                                 this.secondPeriodAttendanceStatusID = 0; /* Present */
                                 this.secondPeriodAttendanceTypeID = 2; /* Amend */
                             } else {
                                 this.secondPeriodAttendanceTypeID = 1; /* OneOff */
                                 this.secondPeriodAttendanceStatusID = 0; /* Present */
                             }
                             break;
                         case 1: // ActivityCompensationType.TwoExcusesForOneCompensation
                             if (this.numberOfExcuses > 1) {
                                 this.numberOfExcuses = waitQueueOperation
                                    ? this.numberOfExcuses
                                    : this.numberOfExcuses - 2;
                                 this.secondPeriodAttendanceStatusID = 0; /* Present */
                                 this.secondPeriodAttendanceTypeID = 2; /* Amend */
                             } else {
                                 this.secondPeriodAttendanceTypeID = 1; /* OneOff */
                                 this.secondPeriodAttendanceStatusID = 0; /* Present */
                             }
                             break;
                         case 2: // ActivityCompensationType.CompensationsDisabled
                             this.secondPeriodAttendanceTypeID = 1; /* OneOff */
                             this.secondPeriodAttendanceStatusID = 0; /* Present */
                             break;
                     }
                 } else {
                     this.secondPeriodAttendanceStatusID = 0; /* Present */;
                 }
             }
         }
     }


     ns.ActivityAttendance.prototype.bookAttendanceByPeriod = function (activityAttendancePeriod) {

         this.bookFirstPeriod(activityAttendancePeriod.am);

         this.bookSecondPeriod(activityAttendancePeriod.pm);
     }


    // #endregion

    // #region ActivityAttendance - Properties




    // 0 - Present
    // 1 - Not present / not excused
    // 2 - Not present / excused
    // 3 - Not present / excused without compensation
    // 4 - Not present / excused without food

    Object.defineProperty(ns.ActivityAttendance.prototype, "firstPeriodAttendanceStatusID", {
        get: function () {
            return this._firstPeriodAttendanceStatusID;
        },
        set: function (value) {

            if (!this.schedule.firstPeriodStartDate) {
                value = 1;
            }

            var valid = true;
            var reserved = !!this.reservation && !!this.reservation.firstPeriodStartDate;

            switch (value) {
                case 0: // Present
                    break;
                case 1: // Not present / not excused
                    break;
                case 2: // Not present / excused
                    valid = reserved || this.firstPeriodAttendanceTypeID == 2;
                    break;
            }

            if (!valid) {
                this.firstPeriodAttendanceTypeID = 0;
                value = 1;
            }

            if (value !== 0) {
                this.firstPeriodStartDate = null;
                this.firstPeriodEndDate = null;
                if (value == 2) {  // Not present / excused
                    this.lunch = false;
                    this.firstSnack = false;

                    if (this.firstPeriodAttendanceTypeID == 2 || // Amend 
                       (!this.reservation || !this.reservation.firstPeriodStartDate && this.firstPeriodAttendanceTypeID == 0)) {
                        value = 1;
                        this.firstPeriodAttendanceTypeID = 0;
                    }
                } else {
                    if (!reserved) {
                        this.lunch = !!(this.attendance && this.attendance.lunch);
                        this.firstSnack = !!(this.attendance && this.attendance.firstSnack);
                    } else {
                        this.lunch = !!this.reservation.lunch;
                        this.firstSnack = !!this.reservation.firstSnack;
                    }
                }
            } else {
                if ((!this.reservation || !this.reservation.firstPeriodStartDate) && this.firstPeriodAttendanceTypeID == 0) {
                    this.firstPeriodAttendanceTypeID = 2;
                }

                if (!this.firstPeriodStartDate || !this.firstPeriodEndDate) {
                    if (this.reservation && !!this.reservation.firstPeriodStartDate) {
                        this.firstPeriodStartDate = this.normalizeDate(this.reservation.firstPeriodStartDate);
                        this.firstPeriodEndDate = this.normalizeDate(this.reservation.firstPeriodEndDate);
                        this.lunch = this.reservation.lunch;
                        this.firstSnack = this.reservation.firstSnack;
                    }
                    if (this.schedule) {
                        this.firstPeriodStartDate = this.normalizeDate(this.schedule.firstPeriodStartDate);
                        this.firstPeriodEndDate = this.normalizeDate(this.schedule.firstPeriodEndDate);
                        this.lunch = this.schedule.lunch;
                        this.firstSnack = this.schedule.firstSnack;
                    }
                }
            }

            this._firstPeriodAttendanceStatusID = value;
        },
        enumerable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "secondPeriodAttendanceStatusID", {
        get: function () {
            return this._secondPeriodAttendanceStatusID;
        },
        set: function (value) {

            if (!this.schedule.secondPeriodStartDate) {
                value = 1;
            }

            var valid = true;
            var reserved = !!this.reservation && !!this.reservation.secondPeriodStartDate;

            switch (value) {
                case 0: // Present
                    break;
                case 1: // Not present / not excused
                    break;
                case 2: // Not present / excused
                    valid = reserved || this.secondPeriodAttendanceTypeID == 2;
                    break;
            }

            if (!valid) {
                this.secondPeriodAttendanceTypeID = 0;
                value = 1;
            }

            if (value > 0) {
                this.secondPeriodStartDate = null;
                this.secondPeriodEndDate = null;
                if (value == 2) {
                    this.secondSnack = false;

                    if (this.secondPeriodAttendanceTypeID == 2) { // Amend 
                        value = 1;
                        this.secondPeriodAttendanceTypeID = 0;
                    }
                } else { //if (value === 1) { 
                    if (!reserved) {
                        this.secondSnack = !!(this.attendance && this.attendance.secondSnack);
                    } else {
                        this.secondSnack = !!this.reservation.secondSnack;
                    }
                }
            } else {
                if ((!this.reservation || !this.reservation.secondPeriodStartDate) && this.secondPeriodAttendanceTypeID == 0) {
                    this.secondPeriodAttendanceTypeID = 2;
                }

                if (!this.secondPeriodStartDate || !this.secondPeriodEndDate) {
                    if (this.reservation && !!this.reservation.secondPeriodStartDate) {
                        this.secondPeriodStartDate = this.normalizeDate(this.reservation.secondPeriodStartDate);
                        this.secondPeriodEndDate = this.normalizeDate(this.reservation.secondPeriodEndDate);
                        this.secondSnack = this.reservation.secondSnack;
                    }
                    if (this.schedule) {
                        this.secondPeriodStartDate = this.normalizeDate(this.schedule.secondPeriodStartDate);
                        this.secondPeriodEndDate = this.normalizeDate(this.schedule.secondPeriodEndDate);
                        this.secondSnack = this.schedule.secondSnack;
                    }
                }
            } 

            this._secondPeriodAttendanceStatusID = value;
        },
        enumerable: true//,
        //configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "firstPeriodActive", {
        get: function () {
            return !!this.schedule.secondPeriodStartDate;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "secondPeriodActive", {
        get: function () {
            return !!this.schedule.secondPeriodStartDate;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "startDate", {
        get: function () {
            return moment(this.schedule.firstPeriodStartDate || this.schedule.secondPeriodStartDate).startOf('day').toDate();
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "weekNo", {
        get: function () {
            return moment(this.schedule.firstPeriodStartDate || this.schedule.secondPeriodStartDate).isoWeek()
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "attending", {
        get: function () {
            return ((!!this.reservation || !!this.attendance) &&
                !(!this.reservation && (
                    this.firstPeriodAttendanceStatusID === 1 &&
                    this.firstPeriodAttendanceTypeID === 0 &&
                    this.secondPeriodAttendanceStatusID === 1 &&
                    this.secondPeriodAttendanceTypeID === 0))) ||
                    (!!this.firstPeriodWaitQueuePosition || !!this.secondPeriodWaitQueuePosition);
        },
        enumerable: true,
        configurable: true
    });

    // 0 - Present
    // 1 - Not present / not excused
    // 2 - Not present / excused
    // 3 - Not present / excused without compensation
    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldShowFirstPeriodTypeIDEdit", {
        get: function () {
            return ((this.firstPeriodAttendanceStatusID == 0 &&
                (!this.reservation || !this.reservation.firstPeriodStartDate)) || (this.firstPeriodAttendanceTypeID != 0)) //&&
               // !this.firstPeriodWaitQueuePosition;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldShowSecondPeriodTypeIDEdit", {
        get: function () {
            return ((this.secondPeriodAttendanceStatusID == 0 &&
                (!this.reservation || !this.reservation.secondPeriodStartDate)) || (this.secondPeriodAttendanceTypeID != 0)) //&&
               // !this.secondPeriodWaitQueuePosition;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "canBeDeleted", {
        get: function () {
            return !this.reservation;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "canBeDeletedWithoutConfirmation", {
        get: function () {
            return !this.reservation && !this.activityAttendanceID;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "clientEditable", {
        get: function () {

            var now = this.momentNow().subtract(1, 'days').startOf('day');
            var startDate = moment(this.schedule.startDate).startOf('day');
            

            return !this.confirmed && now.isBefore(startDate);
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "clientExcusable", {
        get: function () {

            return this.clientEditable &&
                   ((this.firstPeriodAttendanceStatusID == 0 || this.firstPeriodWaitQueuePosition > 0) ||
                    (this.secondPeriodAttendanceStatusID == 0 || this.secondPeriodWaitQueuePosition > 0));
            
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "clientBookable", {
        get: function () {

            if (!this.clientEditable) {
                return false;
            }

            var excused =
                (this.firstPeriodAttendanceStatusID == 2 ||    // Not present / excused
                 this.firstPeriodAttendanceStatusID == 3 ||    // Not present / excused without compensation
                 this.firstPeriodAttendanceStatusID == 4) ||   // Not present / excused without food
                (this.secondPeriodAttendanceStatusID == 2 ||
                 this.secondPeriodAttendanceStatusID == 3 ||
                 this.secondPeriodAttendanceStatusID == 4);

            if (excused) {
                return true;
            }       

            return this.noReservationFirstPeriod || this.noReservationSecondPeriod;

        },
        enumerable: true,
        configurable: true
    });


    Object.defineProperty(ns.ActivityAttendance.prototype, "noReservationFirstPeriod", {
        get: function() {
            return (!this.reservation || (!!this.reservation && !this.reservation.firstPeriodStartDate)) &&
                !!this.schedule.firstPeriodStartDate &&
                this.firstPeriodAttendanceStatusID == 1  && // Not present / not excused
                this.firstPeriodAttendanceTypeID == 0;      // Registered
        }
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "noReservationSecondPeriod", {
        get: function () {
            return (!this.reservation || (!!this.reservation && !this.reservation.secondPeriodStartDate)) &&
                !!this.schedule.secondPeriodStartDate &&
                this.secondPeriodAttendanceStatusID == 1 && // Not present / not excused
                this.secondPeriodAttendanceTypeID == 0;      // Registered
        }
    });


    Object.defineProperty(ns.ActivityAttendance.prototype, "clientBookableCapacityCheck", {
        get: function () {
            return this.clientBookable &&
                ((this.firstPeriodFreeSpots > 0 && !this.shouldDisableFirstPeriodBooking) ||
                    (this.secondPeriodFreeSpots > 0 && !this.shouldDisableSecondPeriodBooking));

        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "firstPeriodFreeSpots", {
        get: function () {
            return Math.max(this.firstPeriodCapacity - this.firstPeriodFilled, 0);
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "showFirstPeriodFreeSpots", {
        get: function () {
            return this.clientBookable && !this.shouldDisableFirstPeriodBooking;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "secondPeriodFreeSpots", {
        get: function () {
            return Math.max(this.secondPeriodCapacity - this.secondPeriodFilled, 0);
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "showSecondPeriodFreeSpots", {
        get: function () {
            return this.clientBookable && !this.shouldDisableSecondPeriodBooking;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldShowFirstPeriodStatus", {
        get: function () {

            var b = !!this.schedule.firstPeriodStartDate &&
                   (
                       (!!this.reservation && !!this.reservation.firstPeriodStartDate) ||
                       (!!this.attendance &&
                          !(this.attendance.firstPeriodAttendanceTypeID == 0 &&
                            this.attendance.firstPeriodAttendanceStatusID == 1 &&
                           (!this.reservation || !this.reservation.firstPeriodStartDate)))
                   );
            return b;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldShowSecondPeriodStatus", {
        get: function () {
            var b = !!this.schedule.secondPeriodStartDate &&
                    (
                        (!!this.reservation && !!this.reservation.secondPeriodStartDate) ||
                        (!!this.attendance &&
                           !(this.attendance.secondPeriodAttendanceTypeID == 0 &&
                             this.attendance.secondPeriodAttendanceStatusID == 1 &&
                            (!this.reservation || !this.reservation.secondPeriodStartDate)))
                    );
            return b;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldDisableFirstPeriodBooking", {
        get: function () {
            return !this.schedule.firstPeriodStartDate || this.firstPeriodAttendanceStatusID == 0;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldDisableSecondPeriodBooking", {
        get: function () {
            return !this.schedule.secondPeriodStartDate || this.secondPeriodAttendanceStatusID == 0;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldDisableFirstPeriodExcuse", {
        get: function () {
            return !this.schedule.firstPeriodStartDate ||
                   (this.firstPeriodAttendanceStatusID != 0 && !this.firstPeriodWaitQueuePosition);
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "shouldDisableSecondPeriodExcuse", {
        get: function () {
            return !this.schedule.secondPeriodStartDate || 
                   (this.secondPeriodAttendanceStatusID != 0 && !this.secondPeriodWaitQueuePosition);
        },
        enumerable: true,
        configurable: true
    });
    
    Object.defineProperty(ns.ActivityAttendance.prototype, "isDirty", {
        set: function (value) {
            this.origAttendance = this.getServerAttendance();   // TODO: This looks suspicious !!!
        },
        get: function () {
            if (this.confirmed) {
                return false;
            }

            var attendance = this.getServerAttendance();
            return !angular.equals(attendance, this.origAttendance);
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "hasNewWaitQueue", {
        get: function () {
            var firstPeriodScheduleWaitQueue = this.schedule.firstPeriodWaitQueue || [];
            var secondPeriodScheduleWaitQueue = this.schedule.secondPeriodWaitQueue || [];

            return this.isDirty && (
                (!!this.firstPeriodWaitQueuePosition && !(_.findIndex(firstPeriodScheduleWaitQueue, ['studentID', this.studentID]) + 1)) ||
                (!!this.secondPeriodWaitQueuePosition && !(_.findIndex(secondPeriodScheduleWaitQueue, ['studentID', this.studentID]) + 1))
            );
        },
        enumerable: true,
        configurable: true
    });


    Object.defineProperty(ns.ActivityAttendance.prototype, "isNotRegularAttendance", {
        get: function () {
            return this.attending &&
                (((this.firstPeriodAttendanceStatusID !== 0 ||
                 this.firstPeriodAttendanceTypeID !== 0) &&
                !(this.firstPeriodAttendanceStatusID === 1 && this.firstPeriodAttendanceTypeID === 0 && this.reservation && !this.reservation.firstPeriodStartDate)) ||
                ((this.secondPeriodAttendanceStatusID !== 0 ||
                 this.secondPeriodAttendanceTypeID !== 0) &&
                !(this.secondPeriodAttendanceStatusID === 1 && this.secondPeriodAttendanceTypeID === 0 && this.reservation && !this.reservation.secondPeriodStartDate)))
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "firstPeriodAttending", {
        get: function () {
            return this.firstPeriodAttendanceStatusID == 0 || // Present
                   this.firstPeriodWaitQueuePosition > 0;
        },
        set: function (value) {
            if (value == this.firstPeriodAttending) {
                return;
            }

            if (!value) {

                var waitQueueOperation = this.firstPeriodWaitQueuePosition > 0;
                if (waitQueueOperation) {
                    this.firstPeriodWaitQueuePosition = 0;
                }

                if (this.firstPeriodAttendanceStatusID == 0 /* Present */) {
                    // Excuse
                    if (this.clientExcusable) {
                        var resetToOrig = this.origAttendance.firstPeriodAttendanceStatusID !== this.firstPeriodAttendanceStatusID ||
                            this.origAttendance.firstPeriodAttendanceTypeID !== this.firstPeriodAttendanceTypeID;

                        var excuseType = resetToOrig
                            ? this.origAttendance.firstPeriodAttendanceStatusID
                            : this.getExcuseType(
                                this.deNormalizeDate(this.firstPeriodStartDate, this.schedule.firstPeriodStartDate), this.momentNow().toDate())

                        if (!waitQueueOperation) {
                            if ((excuseType == 2 /* NotPresentExcused */ ||
                                 excuseType == 4 /* NotPresentExcusedWithoutFood */) &&
                                (this.firstPeriodAttendanceTypeID == 2 /* Amend */ ||
                                 this.firstPeriodAttendanceTypeID == 0 /* Registered */)) {

                                switch (this.activityStudentSetting.activityCompensationTypeID) {
                                    case 0: // OneExcuseForOneCompensation
                                        this.numberOfExcuses = this.numberOfExcuses + 1;
                                        break;
                                    case 1: // TwoExcusesForOneCompensation:
                                        this.numberOfExcuses = this.numberOfExcuses + 2;
                                        break;
                                    case 2: // CompensationsDisabled:
                                        break;
                                }
                            }
                        }
                        this.firstPeriodAttendanceStatusID = excuseType;
                        this.firstPeriodFilled = waitQueueOperation
                            ? this.firstPeriodFilled
                            : this.firstPeriodFilled - 1;
                        if (resetToOrig) {
                            this.firstPeriodAttendanceTypeID = this.origAttendance.firstPeriodAttendanceTypeID;
                        }
                    }
                }
            } else if (value) {
                if (this.clientBookable) {

                    var waitQueueOperation = this.schedule.firstPeriodCapacity <= this.firstPeriodFilled;
                    var resetToWqOrigState = false;

                    if (waitQueueOperation) {
                        var scheduleWaitQueue = this.schedule.firstPeriodWaitQueue || [];

                        resetToWqOrigState = _.findIndex(scheduleWaitQueue, ['studentID', this.studentID]) > -1;

                        this.firstPeriodWaitQueuePosition =
                            (_.findIndex(scheduleWaitQueue, ['studentID', this.studentID]) + 1) || scheduleWaitQueue.length + 1;
                    } else {
                        if ((this.firstPeriodAttendanceTypeID == 2 /* Amend */ ||
                            this.firstPeriodAttendanceTypeID == 0 /* Registered */) &&
                            (this.firstPeriodAttendanceStatusID == 2 /* NotPresentExcused */ ||
                                this.firstPeriodAttendanceStatusID == 4) /* NotPresentExcusedWithoutFood */) {

                            switch (this.activityStudentSetting.activityCompensationTypeID) {
                                case 0: // OneExcuseForOneCompensation:
                                    if (this.numberOfExcuses > 0) {
                                        this.numberOfExcuses = this.numberOfExcuses - 1;
                                    } else {
                                        return; // We do not have any excuses to reuse, so do not allow to change the attendance
                                    }
                                    break;
                                case 1: // TwoExcusesForOneCompensation:
                                    if (this.numberOfExcuses > 1) {
                                        this.numberOfExcuses = this.numberOfExcuses - 2;
                                    } else {
                                        return; // We do not have any excuses to reuse, so do not allow to change the attendance
                                    }
                                    break;
                                case 2: // CompensationsDisabled:
                                    return; // Compensations are disabled;
                            }
                        }
                    }

                    if (!resetToWqOrigState) {
                        this.bookFirstPeriod(true, waitQueueOperation);
                    } else {
                        this.firstPeriodAttendanceTypeID = this.origAttendance.firstPeriodAttendanceTypeID;
                        this.firstPeriodAttendanceStatusID = this.origAttendance.firstPeriodAttendanceStatusID;
                        this.firstPeriodStartDate = this.origAttendance.firstPeriodStartDate;
                        this.firstPeriodEndDate = this.origAttendance.firstPeriodEndDate;
                        this.lunch = this.origAttendance.lunch;
                        this.firstSnack = this.origAttendance.firstSnack;
                    }
                    if (!waitQueueOperation) {
                        this.firstPeriodFilled = this.firstPeriodFilled + 1;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "secondPeriodAttending", {
        get: function () {
            return this.secondPeriodAttendanceStatusID == 0 ||  // Present;
                   this.secondPeriodWaitQueuePosition > 0;
        },
        set: function (value) {
            if (value == this.secondPeriodAttending) {
                return;
            }

            if (!value) { 
                
                var waitQueueOperation = this.secondPeriodWaitQueuePosition > 0;
                if (waitQueueOperation) {
                    this.secondPeriodWaitQueuePosition = 0;
                }

                if (this.secondPeriodAttendanceStatusID == 0 /* Present */) {
                    // Excuse
                    if (this.clientExcusable) {

                        var resetToOrig = this.origAttendance.secondPeriodAttendanceStatusID !== this.secondPeriodAttendanceStatusID ||
                            this.origAttendance.secondPeriodAttendanceTypeID !== this.secondPeriodAttendanceTypeID;

                        var excuseType = resetToOrig
                            ? this.origAttendance.secondPeriodAttendanceStatusID
                            : this.getExcuseType(
                                this.deNormalizeDate(this.secondPeriodStartDate, this.schedule.secondPeriodStartDate), this.momentNow().toDate())

                        if (!waitQueueOperation) {
                            if ((excuseType == 2 /* NotPresentExcused */ ||
                                 excuseType == 4 /* NotPresentExcusedWithoutFood */) &&
                                (this.secondPeriodAttendanceTypeID == 2 /* Amend */ ||
                                 this.secondPeriodAttendanceTypeID == 0 /* Registered */)) {

                                switch (this.activityStudentSetting.activityCompensationTypeID) {
                                    case 0: // ActivityCompensationType.OneExcuseForOneCompensation
                                        this.numberOfExcuses = this.numberOfExcuses + 1;
                                        break;
                                    case 1: // ActivityCompensationType.TwoExcusesForOneCompensation
                                        this.numberOfExcuses = this.numberOfExcuses + 2;
                                        break;
                                    case 2: // ActivityCompensationType.CompensationsDisabled
                                        break;
                                }
                            }
                        }
                        this.secondPeriodAttendanceStatusID = excuseType;
                        this.secondPeriodFilled = waitQueueOperation
                            ? this.secondPeriodFilled
                            : this.secondPeriodFilled - 1;
                        if (resetToOrig) {
                            this.secondPeriodAttendanceTypeID = this.origAttendance.secondPeriodAttendanceTypeID;
                        }
                    }
                }
            } else if (value) {
                if (this.clientBookable) {
                    var waitQueueOperation = this.schedule.secondPeriodCapacity <= this.secondPeriodFilled;
                    var resetToWqOrigState = false;
                    if (waitQueueOperation) {
                        var scheduleWaitQueue = this.schedule.secondPeriodWaitQueue || [];

                        resetToWqOrigState = _.findIndex(scheduleWaitQueue, ['studentID', this.studentID]) > -1;

                        this.secondPeriodWaitQueuePosition =
                            (_.findIndex(scheduleWaitQueue, ['studentID', this.studentID]) + 1) || scheduleWaitQueue.length + 1;
                    } else {
                        if ((this.secondPeriodAttendanceTypeID == 2 /* Amend */ ||
                            this.secondPeriodAttendanceTypeID == 0 /* Registered */) &&
                            (this.secondPeriodAttendanceStatusID == 2 /* NotPresentExcused */ ||
                                this.secondPeriodAttendanceStatusID == 4 /* NotPresentExcusedWithoutFood */)) {

                            switch (this.activityStudentSetting.activityCompensationTypeID) {
                                case 0: // ActivityCompensationType.OneExcuseForOneCompensation
                                    if (this.numberOfExcuses > 0) {
                                        this.numberOfExcuses = this.numberOfExcuses - 1;
                                    } else {
                                        return; // We do not have any excuses to reuse, so do not allow to change the attendance
                                    }
                                    break;
                                case 1: // ActivityCompensationType.TwoExcusesForOneCompensation
                                    if (this.numberOfExcuses > 1) {
                                        this.numberOfExcuses = this.numberOfExcuses - 2;
                                    } else {
                                        return; // We do not have any excuses to reuse, so do not allow to change the attendance
                                    }
                                    break;
                                case 2: // ActivityCompensationType.CompensationsDisabled
                                    return; // Compensations are disabled;
                            }
                        }
                    }
                    if (!resetToWqOrigState) {
                        this.bookSecondPeriod(true, waitQueueOperation);
                    } else {
                        this.secondPeriodAttendanceTypeID = this.origAttendance.secondPeriodAttendanceTypeID;
                        this.secondPeriodAttendanceStatusID = this.origAttendance.secondPeriodAttendanceStatusID;
                        this.secondPeriodStartDate = this.origAttendance.secondPeriodStartDate;
                        this.secondPeriodEndDate = this.origAttendance.secondPeriodEndDate;
                        this.secondSnack = this.origAttendance.secondSnack;
                    }
                    if (!waitQueueOperation) {
                        this.secondPeriodFilled = this.secondPeriodFilled + 1;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "firstPeriodBookable", {
        get: function() {
            return this.firstPeriodClientEditable && this.origAttendance.firstPeriodAttendanceStatusID != 0; /* Present */
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "secondPeriodBookable", {
        get: function () {
            return this.secondPeriodClientEditable && this.origAttendance.secondPeriodAttendanceStatusID != 0 /* Present */;
        },
        enumerable: true,
        configurable: true
    });


    Object.defineProperty(ns.ActivityAttendance.prototype, "firstPeriodClientEditable", {
        get: function () {

            var reservationNotExcused = !!this.reservation &&
                !!this.reservation.firstPeriodStartDate &&
                !!this.attendance &&
                this.attendance.firstPeriodAttendanceStatusID == 1; /* NotPresentNotExcused */

            var attendanceNotExcused = !!this.attendance &&
                this.attendance.firstPeriodAttendanceStatusID == 1 /* NotPresentNotExcused */ &&
                this.attendance.firstPeriodAttendanceTypeID != 0; /* Registered */

            var ce = this.clientEditable && !reservationNotExcused && !attendanceNotExcused;

            var amendReturnPosibble = true;
            if ((this.firstPeriodAttendanceTypeID == 2 /* Amend */ || this.firstPeriodAttendanceTypeID == 0 /* Registered */) &&
                (this.firstPeriodAttendanceStatusID == 2 /* NotPresentExcused */ || this.firstPeriodAttendanceStatusID == 4 /* NotPresentExcusedWithoutFood */)) {
                switch (this.activityStudentSetting.activityCompensationTypeID) {
                    case 0: // ActivityCompensationType.OneExcuseForOneCompensation
                        amendReturnPosibble = this.numberOfExcuses > 0;
                        break;
                    case 1: // ActivityCompensationType.TwoExcusesForOneCompensation
                        amendReturnPosibble = this.numberOfExcuses > 1;
                        break;
                    case 2: // ActivityCompensationType.CompensationsDisabled
                        amendReturnPosibble = false;
                        break;
                }
            }

            var enableOneOffs = true;
            if (!this.activity.enableOneOffAttendance &&
                ((this.origAttendance.firstPeriodAttendanceStatusID === 1 /* NotPresentNotExcused */ &&
                    this.origAttendance.firstPeriodAttendanceTypeID === 0 /* Registered */ &&
                    (!this.reservation || !this.reservation.firstPeriodStartDate)))) {

                if (!this.firstPeriodWaitQueuePosition) {
                    switch (this.activityStudentSetting.activityCompensationTypeID) {
                        case 0: /* ActivityCompensationType.OneExcuseForOneCompensation */
                            enableOneOffs = this.numberOfExcuses > 0 || this.firstPeriodAttendanceStatusID === 0; /* Present */
                            break;
                        case 1: /* ActivityCompensationType.TwoExcusesForOneCompensation */
                            enableOneOffs = this.numberOfExcuses > 1 || this.firstPeriodAttendanceStatusID === 0; /* Present */
                            break;
                        case 2: /* ActivityCompensationType.CompensationsDisabled */
                            enableOneOffs = this.firstPeriodAttendanceStatusID === 0; /* Present */
                            break;
                    }
                }
            }

            var ret = ce && enableOneOffs && amendReturnPosibble;

            return ret;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "isOneOffAttendanceEnabled", {
        get: function () {
            return this.activity.enableOneOffAttendance;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "secondPeriodClientEditable", {
        get: function () {

            var reservationNotExcused = !!this.reservation &&
                !!this.reservation.secondPeriodStartDate &&
                !!this.attendance &&
                this.attendance.secondPeriodAttendanceStatusID == 1; /* NotPresentNotExcused */

            var attendanceNotExcused = !!this.attendance &&
                this.attendance.secondPeriodAttendanceStatusID == 1 /* NotPresentNotExcused */ &&
                this.attendance.secondPeriodAttendanceTypeID != 0 /* Registered */

            var ce = this.clientEditable && !reservationNotExcused && !attendanceNotExcused;

            var amendReturnPosibble = true;
            if ((this.secondPeriodAttendanceTypeID == 2 /* Amend */ || this.secondPeriodAttendanceTypeID == 0 /* Registered */) &&
                (this.secondPeriodAttendanceStatusID == 2 /* NotPresentExcused */ || this.secondPeriodAttendanceStatusID == 4 /* NotPresentExcusedWithoutFood */)) {
                switch (this.activityStudentSetting.activityCompensationTypeID) {
                    case 0: // ActivityCompensationType.OneExcuseForOneCompensation
                        amendReturnPosibble = this.numberOfExcuses > 0;
                        break;
                    case 1: // ActivityCompensationType.TwoExcusesForOneCompensation
                        amendReturnPosibble = this.numberOfExcuses > 1;
                        break;
                    case 2: // ActivityCompensationType.CompensationsDisabled
                        amendReturnPosibble = false;
                        break;
                }
            }

            var enableOneOffs = true;
            if (!this.activity.enableOneOffAttendance &&
                ((this.origAttendance.secondPeriodAttendanceStatusID === 1 /* NotPresentNotExcused */ &&
                    this.origAttendance.secondPeriodAttendanceTypeID === 0 /* Registered */ &&
                    (!this.reservation || !this.reservation.secondPeriodStartDate)))) {

                if (!this.secondPeriodWaitQueuePosition) {
                    switch (this.activityStudentSetting.activityCompensationTypeID) {
                        case 0: /* ActivityCompensationType.OneExcuseForOneCompensation */
                            enableOneOffs = this.numberOfExcuses > 0 || this.secondPeriodAttendanceStatusID === 0; /* Present */
                            break;
                        case 1: /* ActivityCompensationType.TwoExcusesForOneCompensation */
                            enableOneOffs = this.numberOfExcuses > 1 || this.secondPeriodAttendanceStatusID === 0; /* Present */
                            break;
                        case 2: /* ActivityCompensationType.CompensationsDisabled */
                            enableOneOffs = this.secondPeriodAttendanceStatusID === 0; /* Present */
                            break;
                    }
                }
            }

            return ce && enableOneOffs && amendReturnPosibble;
        },
        enumerable: true,
        configurable: true
    });

    Object.defineProperty(ns.ActivityAttendance.prototype, "hasNewOneOff", {
        get: function () {
            return ((this.firstPeriodAttendanceStatusID == 0 /* Present */ && this.firstPeriodAttendanceTypeID == 1 /* OneOff */) &&
                (this.origAttendance.firstPeriodAttendanceStatusID != 0 /* Present */ || this.origAttendance.firstPeriodAttendanceTypeID != 1 /* OneOff */)) ||
                ((this.secondPeriodAttendanceStatusID == 0 /* Present */ && this.secondPeriodAttendanceTypeID == 1 /* OneOff */) &&
                    (this.origAttendance.secondPeriodAttendanceStatusID != 0 /* Present */ || this.origAttendance.secondPeriodAttendanceTypeID != 1 /* OneOff */));
        },
        enumerable: true,
        configurable: true
    });


    // #endregion

}(webooker_acivity_models));